import React from 'react';
import { withRouter, Link, Redirect } from 'react-router-dom';

//HELPERS
import * as c from '../../helpers/constants'
import { callApi } from '../../helpers/methods'

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { campanhaAction } from '../../store/campanha';

//COMPONENTS
import { Row, Column, IBox, Title, Content, Button, Icon, Radio, Return, Select } from '../inspinia'
import ModalPreview from './modalPreview'
import ModalSendTest from './modalSendTest'
import ModalSucesso from './modalSucesso'
import ModalSaibaMais from './modalSaibaMais'

//MASK
import InputMask from 'react-input-mask';

//SWEET ALERT2
import Swal from 'sweetalert2';

class NovaChecklist extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state =
        {
            loading: false,

            form: this.formInitialState(),
            model: this.formModel(),
            comboEnvio:
            {
                results: undefined
            },
            modalPreviewIsOpen: false,
            modalSendTestIsOpen: false,
            modalSucessoIsOpen: false,
            modalSaibaMaisOpen: false,
            disabledInputMask: true,

            //Utilizado para recuperar as informações da campanha 
            idCampanha: this.props.campanha.idCampanha,
            emailUsuario: this.props.auth.user.email,
            usuario: {},
            auth: this.props.auth,

            optionsGet: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
            alerta: Swal.mixin({
                customClass: {
                    confirmButton: "btn btn-primary mx-1",
                    cancelButton: "btn btn-outline btn-primary mx-1",
                    title: "fs-20 fw-600 text-body"
                },
                buttonsStyling: false
            }),
        }

        this.handleChange = this.handleChange.bind(this);
        this.handlePreviewToggle = this.handlePreviewToggle.bind(this);
        this.handleTestToggle = this.handleTestToggle.bind(this);
        this.handleSucessoToggle = this.handleSucessoToggle.bind(this);
        this.handleSaibaMais = this.handleSaibaMais.bind(this); 
        this.handleSave = this.handleSave.bind(this);
        this.handleSend = this.handleSend.bind(this);

        this.state.usuario['email'] = this.state.emailUsuario;

    }

    formInitialState() {

        return {
            assunto: "",
            destinatario: "",
            nomeRemetente: "",
            emailRemetente: "",
            envio: "",
            acao: "",
            dataAgendamento: "",
            template: "",
        }

    }

    formModel() {
        return {
            tipoEnvio: "",
            dataAgendamento: "",
        } 
    }



    componentDidMount() {

        if (this.props.campanha.isSent)
            this.LoadData();

        this.LoadComboEnvio();
    }

    handleChange(e) {

        const form = this.state.form;

        this.setState({ form: { ...form, [e.target.name]: e.target.value } });

    }

    handlePreviewToggle(e) {
        this.setState({ ...this.state, modalPreviewIsOpen: !this.state.modalPreviewIsOpen });
    }

    handleTestToggle(e) {
        this.setState({ ...this.state, modalSendTestIsOpen: !this.state.modalSendTestIsOpen });
    }

    handleSucessoToggle(e) {
        const self = this;
        self.state.alerta.fire({
            title: 'Campanha enviada/agendada com sucesso!',
            html: '<p className="fs-16 fw-300 text-body">Agora é só aguardar o envio.</p>',
            imageUrl: "assets/images/Image 9.png",
            imageAlt: "Envio campanha",
            showCancelButton: true,
            confirmButtonText: 'Criar nova campanha',
            cancelButtonText: '<i class="fa fa-arrow-left mr-2"></i> Voltar para o painel',
            allowOutsideClick: false,
            reverseButtons: true
        }).then((result) => {
            if (result.dismiss === Swal.DismissReason.cancel) {
                self.props.actions.campanha.finalizar().then(() => 
                {
                    self.props.history.push(c.DEFAULT_PRIVATE_ROUTE);
                });
            }

            if (result.isConfirmed) {
                self.props.actions.campanha.finalizar().then(() => 
                {
                    self.props.history.push(c.CAMPAIGN_ROUTE+"/criar");
                });
            }
        });
    }

    handleSaibaMais(e) {
        this.setState({ ...this.state, modalSaibaMaisOpen: !this.state.modalSaibaMaisOpen });
    }

    handleSave(e, send) {
        e.preventDefault(); if (this.state.loading) return;

        let validate1 = this.state.form.envio  || '';
        let validate2 = this.state.form.acao  || '';

        if(validate1 === "" || validate2 === "") {
            c.TOASTER("", "Favor preencher os campos de envio");

        } else {
            const self = this;
            self.setState({ ...this.state, loading: true });

            let idCampanha = this.state.idCampanha;

            self.state.model.tipoEnvio = this.state.form.envio;

            if(self.state.form.acao === 'Aguardando Envio') {
                self.state.model.dataAgendamento = null;

            } else { 
                self.state.model.dataAgendamento = self.state.form.dataAgendamento;

            }

            

            if(send == "enviar") {
                self.state.model.enviar = true;
            }
            
            self.props.actions.campanha.salvarChecklist(self.state.model, idCampanha, self.state.auth).then((response) => {
                if (response.idCampanha) {
                    if(send == "enviar") {
                        self.handleSucessoToggle();
                    } else {
                        c.TOASTER_SUCCESS("Checklist salvo com sucesso!");
                        self.props.history.push(c.PANEL_ROUTE);
                    }                    
                } else {
                    c.TOASTER_INFO(response.message);

                }
            }).catch((error) => {
                self.setState({...this.state, loading: false});
                if (error.message) c.TOASTER(error.type, error.message); else c.TOASTER_ERROR(c.NETWORK_ERROR);
            });
            

        }

        
    }

    handleSend(e) {
        e.preventDefault();

        this.handleSave(e, "enviar");
        
    }

    render() {

        const form = this.state.form;
        const template = this.state.form.template;
        form.envio = "Rastreado";
        

        return (

            <div>
                <ModalPreview isOpen={this.state.modalPreviewIsOpen} toggle={this.handlePreviewToggle} preview={template} />
                <ModalSendTest isOpen={this.state.modalSendTestIsOpen} toggle={this.handleTestToggle} />
                <ModalSucesso isOpen={this.state.modalSucessoIsOpen} toggle={this.handleSucessoToggle} />
                <ModalSaibaMais isOpen={this.state.modalSaibaMaisOpen} toggle={this.handleSaibaMais} />

                {/* MAIN CONTENT */}
                <Row className="mb-5">
                    <Column size="9" className="mx-auto container">
                        {/* MAIN TITLE */}
                        <Row className="mb-3">
                            <Column size="6" className="pl-0">
                                <h2 className="fs-20 fw-600 text-body m-0">Check-list e envio</h2>
                            </Column>

                            <Column size="6" className="pr-0">
                                <div className="input-group d-block fs-14 text-right">                                    
                                    <button type="button" onClick={this.handlePreviewToggle} className="btn btn-link px-3">Pré-visualizar</button>

                                    <button type="button" onClick={this.handleTestToggle} className="btn btn-link px-3">Enviar teste</button>

                                    <button type="button" className="btn btn-link pl-3" onClick={this.handleSave}>Salvar</button>
                                </div>
                            </Column>
                        </Row>

                        {/* FORM */}
                        <Row className="mb-0" style={{ borderTop: "none" }}>
                            <Column size="3" className="pt-3 pl-0">
                                <h3 className="fs-14 fw-600 text-body m-0 mb-3">Detalhes da campanha</h3>

                                <h5 className="fs-12 fw-400 text-muted">
                                    Informações para organizar a campanha  dentro da plataforma.
                                </h5>
                            </Column>

                            <Column size="2"></Column>

                            <Column size="7" className="pt-0 pr-0">
                                <IBox className="mb-0" style={{ borderTop: "solid 4px #e7eaec" }}>
                                    <Content className="border-0 p-4 container">
                                        <Row>
                                            <Column size="1">
                                                <img src="assets/images/mail-icon.svg" />
                                            </Column>

                                            <Column size="11">
                                                <span className="fs-12 text-muted">Assunto</span>
                                            </Column>
                                        </Row>

                                        <Row>
                                            <Column size="11" className="offset-1">
                                                <span className="fs-14 text-body">
                                                    {form.assunto}
                                                </span>
                                            </Column>
                                        </Row>
                                    </Content>

                                    <Content className="p-4 container">
                                        <Row className="row">
                                            <Column size="1">
                                                <img src="assets/images/users2-icon.svg" />
                                            </Column>

                                            <Column size="11">
                                                <span className="fs-12 text-muted">Destinatários</span>
                                            </Column>
                                        </Row>

                                        <Row className="mb-2">
                                            <Column size="11" className="offset-1">
                                                <span className="fs-14 text-body">
                                                    {form.destinatario}
                                                </span>
                                            </Column>
                                        </Row>

                                        <Row>
                                            <Column size="1" className="text-right px-0">
                                                <img src="assets/images/info.svg" className="text-info" />
                                            </Column>

                                            <Column size="11">
                                                <span className="fs-10 text-muted" style={{ display: "inherit", lineHeight: "1.4" }}>
                                                    Após a confirmação do envio a lista não poderá ser utilizada novamente. <br />
                                                    Se precisar enviar para a mesma lista, será necessário importá-la de novo.
                                                </span>
                                            </Column>
                                        </Row>
                                    </Content>

                                    <Content className="p-4 container">
                                        <Row>
                                            <Column size="1">
                                                <img src="assets/images/user3-icon.svg" />
                                            </Column>

                                            <Column size="11">
                                                <span className="fs-12 text-muted">Nome do Remetente</span>
                                            </Column>
                                        </Row>

                                        <Row>
                                            <Column size="11" className="offset-1">
                                                <span className="fs-14 text-body">
                                                    {form.nomeRemetente}
                                                </span>
                                            </Column>
                                        </Row>
                                    </Content>

                                    <Content className="p-4 container">
                                        <Row>
                                            <Column size="1">
                                                <img src="assets/images/respostas-icon.svg" />
                                            </Column>

                                            <Column size="11">
                                                <span className="fs-12 text-muted">E-mail do Remetente</span>
                                            </Column>
                                        </Row>

                                        <Row>
                                            <Column size="11" className="offset-1">
                                                <span className="fs-14 text-body">
                                                    {form.emailRemetente}
                                                </span>
                                            </Column>
                                        </Row>
                                    </Content>
                                </IBox>
                            </Column>
                        </Row>

                        {/* FORM */}
                        <Row className="mb-4" style={{ borderTop: "solid 1px #e9e9e9" }}>
                            <Column size="3" className="pt-3 pl-0">
                                <h3 className="fs-14 fw-600 text-body m-0 mb-3">Envio</h3>

                                <h5 className="fs-12 fw-400 text-muted">
                                    Selecione uma opção de envio.
                                </h5>
                            </Column>

                            <Column size="2"></Column>

                            <Column size="7" className="pt-0 pr-0">
                                <IBox className="mb-0">
                                    <Content className="border-0 p-4 container">
                                        <Row className="mb-3 text-right">
                                            <Column>
                                                <a onClick={this.handleSaibaMais} className="text-success fs-12"><u>Saiba mais</u></a>
                                            </Column>
                                        </Row>

                                        <Row className="my-0 text-center">
                                            <Column size="4">
                                                <Row className="mb-2">
                                                    <Column style={{ height: "40px" }}>
                                                        <img src="assets/images/006-search.svg" />
                                                    </Column>
                                                </Row>

                                                <Row className="mb-2">
                                                    <Column>
                                                        <span>Rastreado</span>
                                                    </Column>
                                                </Row>

                                                <Row className="mb-0">
                                                    <Column>
                                                        <Radio name="envio" 
                                                            value="Rastreado" 
                                                            selected={form.envio} 
                                                            onClick={this.handleChange}
                                                            disabled={this.state.ativarRastreado} />
                                                    </Column>
                                                </Row>
                                            </Column>
                                        </Row>

                                        <Row className="my-3">
                                            <Column size="11" className="mx-auto">
                                                <Select name="acao" selected={form.acao} data={this.state.comboEnvio} onChange={this.handleChange} placeholder="Ações" />
                                            </Column>
                                        </Row>

                                        {form.acao == "Agendado" && (
                                            <Row className="my-3">
                                            <Column size="11" className="mx-auto">
                                                <InputMask 
                                                    mask="99/99/9999 99:99:99" 
                                                    name="dataAgendamento" 
                                                    value={form.dataAgendamento} 
                                                    placeholder="___/___/___ ___:___"                                                 
                                                    onChange={this.handleChange} 
                                                    className="form-control"/>                                           
                                            </Column>
                                            </Row>
                                        )}
                                        

                                    </Content>
                                </IBox>
                            </Column>
                        </Row>

                        {/* SAVE */}
                        <Row className="mb-0">
                            <Column size="5" className="pl-0"></Column>

                            <Column size="7" className="pr-0 clearfix">
                                <div className="float-left">
                                    {this.props.campanha.editor && (
                                        <Return to={c.CAMPAIGN_ROUTE + "/nova/editor-" + this.props.campanha.editor.type} className="mx-1" width="130px" />
                                    )}                                    
                                </div>

                                <div className="float-right">
                                    <Button disabled={this.state.loading} type="button" className="px-5" onClick={this.handleSend}>Enviar</Button>
                                </div>
                            </Column>
                        </Row>
                    </Column>
                </Row>
            </div>
        );
    }

    LoadData() {
        let self = this;

        let idCampanha = this.state.idCampanha;

        const url = `${c.API_CAMPAIGN_URL}/public/campaign/fluxo/check-list/${idCampanha}`;

        const options = this.state.optionsGet;

        callApi(url, options, function (response) {              
            self.setState({ ...self.state, form: response });
        });

    }

    LoadComboEnvio() {
        const options = {
            "results": [
                {
                    "value": "Aguardando Envio",
                    "label": "Enviar Agora"
                },
                {
                    "value": "Agendado",
                    "label": "Agendar"
                }
            ]
        };

        this.setState({ ...this.state, comboEnvio: options });
    }

}

function mapStateToProps(state) {
    return { auth: state.auth, campanha: state.campanha };
}
function mapDispatchToProps(dispatch) {
    return { actions: { campanha: bindActionCreators(campanhaAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NovaChecklist));
